import React from 'react'
import { motion } from 'framer-motion';
import {images} from "../../constants"
import { AppWrap } from '../../wrapper';
import Typical from 'react-typical'
import './Header.scss'

const scaleVariants = {
  whileInView:{
    scale: [0,1],
    opacity: [0,1],
    transition :{
     duration: 1,
     ease: "easeInOut" 
    }
  }
}

const Header = () => {
  return (
    <div className='app__header app__flex'>
      <motion.div
        whileInView={{ y:[-100, 0], opacity: [0, 1] }}
        // whileHover={{scale: [1, 0.9]}}
        transition={{duration: 0.85}}
        className="app__header-info"
      >
        <img src={images.profile2} alt="profile_bg" />
          <h4 style={{fontFamily:'Verdana, Geneva, Tahoma, sans-serif'}}>Hello<span>.</span></h4>
          <h3 style={{fontWeight:'lighter', fontFamily:'Verdana, Geneva, Tahoma, sans-serif'}}>I am Muhammad Kabiru Suleiman</h3>
        <div className='span'>
           <h3 style={{color: ''}}>
                  {" "}
                   <Typical
                       loop={Infinity}
                       steps={[
                           "Full Stack Developer 💻",
                           1000,
                           "MERN Stack Dev 😎",
                           1000,
                           "Cross Platform Dev 🌐",
                           1000,
                           "React Dev 📱",
                           1000,
                           "PHP Developer ❄️",
                           1000
                       ]}
                   />        
            </h3>
          {/* <span> &#x2B50; Full Stack Developer</span>
        <span >&#x2B50; MERN Stack Developer</span> */}
        </div>
        <div className='btn-div'>
          {/* <a href='https://docs.google.com/document/d/1fpGzycrgZwwAlX2fhcHNcNeaHcaLEIZt_iA__Zhr9Hg/edit?usp=sharing' download='001Muhammad.pdf' target='_blank' without rel="noreferrer"><button>Resume</button></a> */}
          <a href='Sbieey.pdf' download='001Muhammad.pdf'>
                            <button className='btn highlighted-btn'>Get Resume</button>
                        </a>
          <a href='#about' ><button>About Me</button></a>
        </div>
        
        
        {/* <h6>Enthusiastic Developer</h6> */}
        <div className="app__header-badge">
          {/* <div className="badge-cmp app__flex">
            <span>&#x1F44B;</span>
            <div style={{marginLeft:20}}>
              <p className='p-text'>Hello, I am</p>
              <h1 className='head-text'>Muhammad</h1>
            </div>
          </div> */}
           {/* <motion.div
              transition={{duration:1}}
              whileInView={{x:[-200, 1]}}
            >
          <div className='tag-cmp app__flex'>
              <p className='p-text'>Full Stack Developer</p>
          </div>
          <motion.div
              transition={{duration: 2}}
              whileInView={{x:[-200, 1]}}
              whileHover={{scale: [1, 0.9]}}
            >
            <div className='tag-cmp app__flex'>
              <p className='p-text'>MERN Stack Dev</p>
            </div>
            </motion.div>
          
          </motion.div> */}
        </div>
      </motion.div>

      <motion.div
        whileInView={{ opacity: [0, 1] }}
        transition={{duration: 0.5, delayChildren: 0.5}}
        // className="app__header-img"
      >
        {/* <img src={images.profile2} alt="profile_bg" /> */}
        {/* <motion.img 
          whileInView={{ scale: [0, 1] }}
          transition={{duration: 1, ease: "easeInOut"}}
          // src = {images.circle}
          // alt = "profile_circle"
          className='overlay_circle'
        /> */}
      </motion.div>

      <motion.div
        variants={scaleVariants}
        whileInView={scaleVariants.whileInView}
        className="app__header-circles"
      >
        {/* {[images.graphql, images.react, images.sass, images.typescript].map((circle, index) => (
          <div className='circle-cmp app__flex' key={`circle-${index}`}>
            <img src={circle} alt="circle"/>
          </div>
        ))} */}
        
      </motion.div>
    </div>
  )
}

export default AppWrap(Header, 'home')